export default __webpack_public_path__ + "static/media/blog-post-layout-05-img-06.92af93d1.jpg";